/**
 * Transforms organization ids into a list of organization ids that include parent paths, since
 * DataTree component uses all unique id's
 * */
export function selectInitialOrgs(initialIds, orgs, path = []) {
    const result = [];
    for (const organization of orgs) {
        const newPath = [...path, organization.id];
        if (initialIds.includes(organization.id.split('_')[0])) {
            result.push(organization.id);
        }
        if (organization.children) {
            result.push(...selectInitialOrgs(initialIds, organization.children, newPath));
        }
    }
    return result;
}
